import { useCallback } from 'react';
import { useLocalStorageValue } from '@lumahealthhq/ui-utils';
import { EModelEnv, createAxiosClientDeprecated } from '../utils';
import useKeyAuthToken from './useKeyAuthToken';
import useKeyEnv from './useKeyEnv';
import useModelContext from './useModelContext';

/**
 * @deprecated use `@lumahealthhq/ui-utils#usePodName`
 */
export default function useCurrentEnv() {
  const keyEnv = useKeyEnv();
  const keyAuthToken = useKeyAuthToken();
  const [env, setEnv] = useLocalStorageValue(keyEnv, EModelEnv.Staging);
  const setAxiosClientDeprecated = useModelContext(s => s.setAxiosClient);

  // Update the axiosClient when the env changes
  const setEnvWrapper = useCallback(newEnv => {
    setEnv(newEnv);
    setAxiosClientDeprecated == null ? void 0 : setAxiosClientDeprecated(createAxiosClientDeprecated(keyAuthToken, newEnv));
  }, [setEnv, setAxiosClientDeprecated, keyAuthToken]);
  return [env, setEnvWrapper];
}